<template>
  <Footer class="footer" ref="pageFooter">
    <div class="out">
      <div style="display: flex;flex-direction: column;flex-shrink: 0">
        <a :href="util.getPrivacyProtocal()" class="protocal" style="margin-top: 0">隐私政策</a>
        <a :href="util.getUserProtocal()" class="protocal">用户协议</a>
      </div>
      <div class="footer-links">
        <p>联系我们</p>
        <div style="margin-top: 10px">邮箱：miguan2008@163.com</div>
        <div style="display: flex;margin-top: 10px">
          <div>商务联系：</div>
          <img class="qr-placeholder" style="margin-bottom: 0px;" src="@/assets/img/contact_bd.png"><img/>
        </div>
      </div>
      <div class="footer-qr-codes">
        <div class="qr-code-item">
          <img class="qr-placeholder" src="@/assets/img/wx_gzh.png"></img>
          <p>关注大熊兼职公众号</p>
        </div>
        <!--        <div class="qr-code-item">-->
        <!--          <img class="qr-placeholder" src="@/assets/img/qrcode.jpg"></img>-->
        <!--          <p>大熊兼职小程序</p>-->
        <!--        </div>-->
        <!--        <div class="qr-code-item">-->
        <!--          <img class="qr-placeholder" src="@/assets/img/qrcode_shangjia.jpg"></img>-->
        <!--          <p>大熊兼职商家版小程序</p>-->
        <!--        </div>-->
      </div>
    </div>
    <div class="footer-bottom">
      <p>©2025 上海米罐网络科技有限公司 / 版权所有. <a href="https://beian.miit.gov.cn">沪ICP备2023016207号-1</a></p>
    </div>
  </Footer>
</template>

<script>
export default {
  name: 'TheFooter',
  mounted() {
    // 1. 获取当前组件 DOM 内部的所有 <a> 标签
    // $el 是 Vue 实例的根 DOM 元素
    const links = this.$el.querySelectorAll('a');

    // 2. 遍历所有链接并添加属性
    links.forEach(link => {

      // ===============================================
      // 排除逻辑：检查是否设置了排除标记
      // ===============================================
      if (link.hasAttribute('data-target-self')) {
        // 如果链接有 data-target-self 属性，则跳过此次循环，不添加 target="_blank"
        return;
      }

      // 检查链接是否是内部路由链接（通常不需要新窗口打开）
      // 这里假设所有以 "/" 开头的内部链接都不需要修改
      const href = link.getAttribute('href');

      if (href && !href.startsWith('/') && !href.startsWith('#')) {
        // 确保它是一个外部链接（不以 / 或 # 开头）
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
      // 💡 另一种做法是直接对所有链接应用，如果您确定所有链接都需要新窗口打开：
      // link.setAttribute('target', '_blank');
      // link.setAttribute('rel', 'noopener noreferrer');
    });
  }
}
</script>

<style scoped>
.footer {
  background-color: #333;
  color: #aaa;
  padding: 60px 0 0 0;
}

.out {
  display: flex;
  padding-left: 54px;
  padding-right: 70px
}

.protocal {
  color: #EFEFEF;
  font-size: 16px;
  text-decoration: none;
  margin-right: 20px;
  flex-shrink: 0;
  margin-top: 20px;
}

.footer-links {
  font-size: 16px;
  color: #EFEFEF;
  margin-left: 30px;
}

.footer-qr-codes {
  display: flex;
  margin-left: auto;
}

.qr-code-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 40px;
}

.qr-placeholder {
  width: 100px;
  height: 100px;
  margin-bottom: 14px;
}

.qr-code-item p {
  font-size: 16px;
  color: #EFEFEF;
}

.footer-bottom {
  text-align: center;
  font-size: 16px;
  color: #9A9A9A;
  padding-top: 100px;
  padding-bottom: 40px;
}

.footer-bottom a {
  font-size: 16px;
  color: #9A9A9A;
}

@media screen and (max-width: 768px) {
  .footer {
    padding: 30px 0 0 0;
  }

  .out {
    padding-left: 14px;
    padding-right: 10px
  }

  .protocal {
    font-size: 13px;
    margin-right: 10px;
    margin-top: 10px;
  }

  .footer-links {
    font-size: 14px;
    margin-left: 10px;
  }

  .qr-code-item {
    margin-left: 0px;
  }

  .qr-placeholder {
    width: 60px;
    height: 60px;
    margin-bottom: 7px;
  }

  .qr-code-item p {
    font-size: 12px;
  }

  .footer-bottom {
    font-size: 12px;
    padding: 20px;
  }

  .footer-bottom a {
    font-size: 12px;
  }
}
</style>
